import { ConversationChannelContentTypeMap } from 'lib-shared-legacy-types';

/**
 * Channels that support message delivery status tracking.
 *
 * - Email: Email delivery via SMTP
 * - Contactform: Contact form submissions
 * - Whatsapp: WhatsApp messages via WhatsApp Business API
 */
const channelsWithDeliveryStatus: (keyof ConversationChannelContentTypeMap)[] =
  ['email', 'contactform', 'whatsapp'];

export function hasChannelDeliveryStatus(
  channel: keyof ConversationChannelContentTypeMap,
): boolean {
  return channelsWithDeliveryStatus.includes(channel);
}
